'use client';

import { type CartStep, useCartStepper } from '@eliadmin/core/src/hooks/cart/use-cart-stepper';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Button, type ButtonProps } from '../ui/button';

import { HiOutlineArrowRightCircle } from 'react-icons/hi2';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { LuArrowLeft } from 'react-icons/lu';

interface CartNavigationButtonProps {
  className?: string;
  step: CartStep;
  variant?: ButtonProps['variant'];
  size?: ButtonProps['size'];
  title?: string;
  beforeIcon?: boolean;
  afterIcon?: boolean;
  disabled?: boolean;
  /** Runs before the step change; returning `false` keeps the user on the current step. */
  onBeforeContinue?: () => boolean | Promise<boolean>;
}

export function CartNavigationButton({
  className,
  step,
  variant,
  title,
  beforeIcon,
  afterIcon,
  disabled,
  size,
  onBeforeContinue,
}: CartNavigationButtonProps) {
  const { setStep } = useCartStepper();
  const { t } = useTranslations();

  const handleContinue = async () => {
    if (onBeforeContinue && !(await onBeforeContinue())) return;
    setStep(step);
  };

  return (
    <Button
      onClick={handleContinue}
      disabled={disabled}
      variant={variant ?? 'default'}
      size={size ?? 'default'}
      className={cn('w-full sm:w-fit', 'ea-cart-summary-card__continue-button', className)}
    >
      {beforeIcon && <LuArrowLeft size={20} aria-hidden />}
      <p className={cn((size === 'icon' || size === 'icon-lg') && 'hidden')}>
        {title ? title : t('text526')}
      </p>
      {afterIcon && <HiOutlineArrowRightCircle size={20} aria-hidden />}
    </Button>
  );
}
